import type { SVGProps } from 'react';
const SvgNearMe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#near_me_svg__a)">
      <path
        fill="currentColor"
        d="M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3Z"
      />
    </g>
    <defs>
      <clipPath id="near_me_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNearMe;
